import { isNonEmptyArray } from '@caresend/utils';
import 'immutability-helper';
import '../../../../router/helpers/initRouter.js';
import '../../../../router/routes/dev/model.js';
import '../../../../router/routes/dev/routes.js';
import '../../../../router/routes/dashboard/model.js';
import '../../../../router/routes/pro/model.js';
import '../../../../router/routes/visitsPage/model.js';
import '@caresend/types';
import '../../../../router/routes/orderFlow/model.js';
import '../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../router/routes/orderFlow/routes.js';
import '../../../../router/routes/schedulingFlow/model.js';
import '../../../../router/routes/schedulingFlow/routes.js';
import { ChartingFlowRouteName } from '../../../../router/routes/chartingFlow/model.js';
import '../../../../router/routes/chartingFlow/routes.js';
import '../../../../router/routes/portal/portalRoutes.js';
import '../../../../router/routes/portal/model.js';
import '../../../../router/routes/visitsPage/routes.js';
import { getStore } from '../../../helpers/initStore.js';

const getChartingFlowVisitSpecimenBagsStepFailures = (route) => {
    var _a, _b;
    const store = getStore();
    const { orderID } = route.params;
    const failures = {};
    if (!orderID) {
        return ['Error with Order ID. Contact CareSend'];
    }
    const checkSpecimenBagsHaveRequiredData = () => {
        var _a, _b;
        let validationPassed = true;
        Object.values((_b = (_a = store.state.chartingFlow.data[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _a === void 0 ? void 0 : _a.specimenBags) !== null && _b !== void 0 ? _b : {}).forEach((bag, index) => {
            if (!bag.serial) {
                failures[`Specimen bag ${index + 1} has no barcode number`] = true;
                validationPassed = false;
            }
            if (!bag.taskID) {
                failures[`Specimen bag ${index + 1} has no task selected`] = true;
                validationPassed = false;
            }
        });
        return validationPassed;
    };
    const checkSerialsHaveBeenEntered = () => {
        var _a, _b;
        return Object.values((_b = (_a = store.state.chartingFlow.data[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _a === void 0 ? void 0 : _a.specimenBags) !== null && _b !== void 0 ? _b : {}).map((specimenBag, index) => {
            if (!specimenBag.serial) {
                failures[`Specimen bag ${index + 1} has no barcode number`] = true;
            }
            return !specimenBag.serial;
        });
    };
    const isDraftOrder = store.getters['chartingFlow/isDraftOrder'](orderID);
    if (isDraftOrder) {
        if (!Object.values((_b = (_a = store.state.chartingFlow.data[orderID !== null && orderID !== void 0 ? orderID : '']) === null || _a === void 0 ? void 0 : _a.specimenBags) !== null && _b !== void 0 ? _b : {}).length) {
            failures['At least one specimen bag must be added'] = true;
        }
        else {
            checkSpecimenBagsHaveRequiredData();
        }
    }
    else {
        checkSerialsHaveBeenEntered();
    }
    const failuresArray = Object.keys(failures);
    if (isNonEmptyArray(failuresArray))
        return failuresArray;
    return null;
};
/**
 * Validators to determine when the `Next` button should be enabled on
 * charting flow steps.
 */
const chartingFlowStepValidators = {
    [ChartingFlowRouteName.SPECIMEN_BAGS]: getChartingFlowVisitSpecimenBagsStepFailures,
};

export { chartingFlowStepValidators, getChartingFlowVisitSpecimenBagsStepFailures };
